var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 21,
    rx: 20.5,
    ry: 21,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7495 30.0355C18.7721 30.5746 19.2157 31 19.7551 31H29.1514C29.6909 31 30.1345 30.5746 30.157 30.0355L30.8281 15.8701H18.0785L18.7495 30.0355ZM26.5788 19.3885C26.5788 19.1628 26.7618 18.9798 26.9876 18.9798H27.6415C27.8672 18.9798 28.0504 19.1628 28.0504 19.3885V27.4816C28.0504 27.7073 27.8673 27.8903 27.6415 27.8903H26.9876C26.7619 27.8903 26.5788 27.7074 26.5788 27.4816V19.3885ZM23.7176 19.3885C23.7176 19.1628 23.9006 18.9798 24.1263 18.9798H24.7802C25.0059 18.9798 25.189 19.1628 25.189 19.3885V27.4816C25.189 27.7073 25.006 27.8903 24.7802 27.8903H24.1263C23.9006 27.8903 23.7176 27.7074 23.7176 27.4816V19.3885ZM20.8562 19.3885C20.8562 19.1628 21.0392 18.9798 21.265 18.9798H21.9189C22.1446 18.9798 22.3277 19.1628 22.3277 19.3885V27.4816C22.3277 27.7073 22.1447 27.8903 21.9189 27.8903H21.265C21.0393 27.8903 20.8562 27.7074 20.8562 27.4816V19.3885Z",
    fill: "#132342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2748 12.0303H26.94V11.2108C26.94 11.0944 26.8456 11 26.7292 11H22.1772C22.0608 11 21.9665 11.0944 21.9665 11.2108V12.0303H17.6316C17.2828 12.0303 17 12.3131 17 12.6619V14.6462H31.9064V12.662C31.9064 12.3131 31.6237 12.0303 31.2748 12.0303Z",
    fill: "#132342"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_7",
    x: 0,
    y: 0,
    width: 49,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_7",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.a0f6a9bccdbbe328d17d03c1a026d95d.svg";
export { ForwardRef as ReactComponent };